import { RowHoverCapCombinedProps } from './types';

const usePresenter = (props: RowHoverCapCombinedProps): RowHoverCapCombinedProps => {
  return props;
};

export default usePresenter;
